import React, { useEffect, useState } from 'react';
import './Home.css';
import Navbar from '../Navbar/Navbar';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay, Pagination } from 'swiper/modules';
import './Testimonial.css'; // Make sure this matches your filename

const Home = () => {


 const [combinedData, setCombinedData] = useState([]);

useEffect(() => {
  const fetchData = async () => {
    try {
      const res = await fetch('https://api.lbnhyderabad.com/auth-mp/api/categories');
      const data = await res.json();

      // ✅ Make sure it's an array before setting state
      if (Array.isArray(data)) {
        setCombinedData(data);
      } else {
        console.warn("Unexpected API response format:", data);
        setCombinedData([]); // fallback
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCombinedData([]); // fallback on error
    }
  };

  fetchData();
}, []);


  const topTenProducts = combinedData.slice(0, 12);
  
  return (
    <>

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            Welcome to <span className="highlight">LBN</span> Marketplace
          </h1>
          <p className="hero-subtitle">
            Your trusted platform to connect product needs with verified lions clubs members
          </p>
          <a href="/login" className="cta-button">Submit Requirement</a>
        </div>
      </section>

   <section className="about">
  <div className="about-container">
    <div className="about-text">
      <h2 className="section-title">What We Do</h2>
      <p>
        LBN Marketplace is not your average e-commerce platform. We bridge the gap between buyers with precise needs and verified lions clubs members who can fulfill them. 
        Whether you're sourcing specific products or bulk quantities, simply log in, submit your requirement, and let the right lions clubs members come to you.
      </p>
    </div>
    <div className="about-image">
      <img src="https://api.lbnhyderabad.com/images/image-1753506212381.head3.jpg" alt="Marketplace Concept" />
    </div>
  </div>
</section>


  {/* Products Section */}
      <section className="products">
        <h2 className="section-title">Featured Products</h2>
        <div className="product-grid">
          {combinedData.length === 0 ? (
            <p style={{ color: '#faae2f', fontSize: '1.2rem' }}>Loading products...</p>
          ) : (
            combinedData.map(product => (
              <div key={product.id} className="product-card">
                <div className="product-image-wrapper">
                  <img src={product.image_url} alt={product.name} className="product-image" />
                 
                </div>
                <h3 className="product-name">{product.name}</h3>
          
                {/* <a href="/login" className="btn-cta">Submit Requirement</a> */}
              </div>
            ))
          )}
        </div>
      </section>


{/* How It Works Section */}

<section className="how-it-works">
  <h2 className="section-title">How It Works</h2>
  <div className="steps">
    <div className="step">
      <div className="step-icon">🔐</div>
      <h3>1. Login</h3>
      <p>Create or log into your account to get started.</p>
    </div>
    <div className="step">
      <div className="step-icon">📝</div>
      <h3>2. Submit Requirement</h3>
      <p>Fill in a detailed form specifying what you need — product type, quantity, specs, etc.</p>
    </div>
    <div className="step">
      <div className="step-icon">📬</div>
      <h3>3. Dealer Contact</h3>
      <p>Your requirement is shared with verified dealers who contact you with tailored offers.</p>
    </div>
  </div>
</section>


{/* Testimonials or Value Proposition */}
  <section className="testimonials">
      <h2 className="section-title">Why Use LBN?</h2>

    <Swiper
  modules={[Autoplay, Pagination]}
  spaceBetween={30}
  slidesPerView={1}
  loop={true}
  centeredSlides={true}
  autoplay={{
    delay: 5000,
    disableOnInteraction: false,
  }}
  pagination={{ clickable: true }}
  className="testimonial-slider"
>

        <SwiperSlide>
          <div className="testimonial-card">
            <p>"I found the exact supplier I needed within a day. So much faster than cold calling!"</p>
            <p className="testimonial-author">– Aditi R., Buyer</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="testimonial-card">
            <p>"As a dealer, I get high-quality leads directly in my inbox. Great platform!"</p>
            <p className="testimonial-author">– Ramesh S., Dealer</p>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="testimonial-card">
            <p>"The process is seamless. I submitted a requirement and had three offers within hours."</p>
            <p className="testimonial-author">– Neha P., Buyer</p>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <p>&copy; 2026 LBN Marketplace. All Rights Reserved.</p>
          <div className="footer-links">
            <a href="/about">About</a>
            <a href="/contact">Contact</a>
            <a href="/privacy">Privacy Policy</a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Home;
